import { render, staticRenderFns } from "./Manage.vue?vue&type=template&id=477b1f5a&scoped=true&"
import script from "./Manage.vue?vue&type=script&lang=js&"
export * from "./Manage.vue?vue&type=script&lang=js&"
import style0 from "styles/views/oem/manage.css?vue&type=style&index=0&id=477b1f5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477b1f5a",
  null
  
)

export default component.exports